import React from 'react';
import { motion } from 'framer-motion';
import { PRICE } from '../data/offer';
import { Reveal } from './Reveal';
import { PdfIcon, RefundIcon, ShieldIcon } from './icons/CraftIcons';
const promises = [{
  id: 'p1',
  icon: PdfIcon,
  text: 'Download all 15 PDFs the moment you pay.'
}, {
  id: 'p2',
  icon: RefundIcon,
  text: 'Email us within 30 days for a full refund.'
}, {
  id: 'p3',
  icon: ShieldIcon,
  text: 'Keep the 1,000+ patterns anyway. No catch.'
}];
export function Guarantee() {
  return <section aria-labelledby="guarantee" className="w-full bg-cream px-4 py-10 sm:px-6 sm:py-14 lg:py-24" data-id="element-111" data-mp="14g64m3h4so7s">
      <div className="perspective-stage mx-auto max-w-[900px]" data-id="element-112" data-mp="1j5c4ltnsmigq">
        <Reveal data-id="element-113" data-mp="1ee3qwlffkaxr">
          <div className="relative overflow-hidden rounded-[28px] border-2 border-sage bg-ivory px-5 py-8 text-center shadow-lift sm:px-12 sm:py-10" data-id="element-114" data-mp="1edk872hyhiio">
            <motion.div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border-[3px] border-sage-tint bg-sage text-white shadow-[0_14px_26px_rgba(74,92,62,0.35)]" initial={{
            scale: 0.8,
            rotate: -8,
            opacity: 0
          }} whileInView={{
            scale: 1,
            rotate: 0,
            opacity: 1
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 16
          }} data-id="element-115" data-mp="qm6kxaynwd4k">
              <ShieldIcon className="h-9 w-9" strokeWidth={1.6} data-id="element-116" data-mp="12qeq8cx3am0n" />
            </motion.div>

            <span className="mt-5 inline-block rounded-full bg-sage-tint px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-sage-dark" data-id="element-117" data-mp="61yw03j1boh7">
              Section 6 — The insane guarantee
            </span>
            <h2 id="guarantee" className="mt-4 font-display text-3xl font-bold leading-tight text-ink sm:text-[38px]" data-id="element-118" data-mp="f3gbbjombm4u">
              The &ldquo;Better Than Free&rdquo; Guarantee
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-ink-soft sm:text-base" data-id="element-119" data-mp="1vfbvnfg7cobz">
              Buy the Treasury. Download all 15 PDFs. If you don&rsquo;t feel like you just robbed
              us &mdash; if this isn&rsquo;t the best ${PRICE.today} you&rsquo;ve ever spent on your
              craft &mdash; email us within 30 days. We refund your ${PRICE.today} immediately.{' '}
              <strong className="font-extrabold text-ink" data-id="element-120" data-mp="bxdfj97pkpa">
                And you keep the 1,000+ patterns anyway.
              </strong>
            </p>

            <div className="mt-6 grid gap-3 text-left sm:mt-8 sm:grid-cols-3 sm:gap-4" data-id="element-121" data-mp="38sigykj2rll0">
              {promises.map((promise, index) => {
              const Icon = promise.icon;
              return <Reveal key={promise.id} delay={0.08 * index} data-id="element-122" data-mp="3ik4u4mez3uqe" data-mpi={index}>
                    <div className="flex h-full items-start gap-3 rounded-2xl border border-hairline bg-cream p-4" data-id="element-123" data-mp="3dqjyh10urcud">
                      <Icon className="mt-0.5 h-5 w-5 shrink-0 text-sage-dark" data-id="element-124" data-mp="2pzwnu7zjy944" />
                      <p className="text-xs leading-relaxed text-ink-soft sm:text-sm" data-id="element-125" data-mp="2l1v4rn24m9sn">
                        {promise.text}
                      </p>
                    </div>
                  </Reveal>;
            })}
            </div>

            <p className="mt-6 font-display text-lg font-bold text-sage-dark sm:mt-7 sm:text-xl" data-id="element-126" data-mp="rk7a6w8y5l3l">
              You literally cannot lose unless you walk away.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}